<div class="body">

    <ng-container *ngIf="attachements.length === 0; else hasattachements">

        <span class="no-attachements">Keine Anhänge</span>

    </ng-container>

    <ng-template #hasattachements>

        <div class="file-wrapper" *ngFor="let attachement of attachements | slice:0:limit">

            <span class="file-icon fiv-sqo file-icon" [ngClass]="attachement.icon" [matTooltip]="attachement.name"></span>
    
        </div>

        <span class="more-counter" *ngIf="attachements.length > limit">
            {{attachements.length - limit}}
        </span>

    </ng-template>

</div>